import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { trackPixelEvent } from '../hooks/useMetaPixel';
type CtaButtonProps = {
  children: React.ReactNode;
  size?: 'md' | 'lg';
  className?: string;
  /** Destination for this button. Defaults to the on-page offer section. */
  href?: string;
  /** Set for external destinations such as the checkout. */
  external?: boolean;
};
export function CtaButton({
  children,
  size = 'lg',
  className = '',
  href = '#offerta',
  external = false
}: CtaButtonProps) {
  const sizing = size === 'lg' ? 'px-9 py-4 text-[13px]' : 'px-7 py-3.5 text-[12px]';
  return <a href={href} {...external ? {
    target: '_blank',
    rel: 'noopener noreferrer'
  } : {}} onClick={() => trackPixelEvent('InitiateCheckout', {
    content_name: 'Scienze Pronta',
    value: 19,
    currency: 'EUR'
  })} className={`group inline-flex items-center justify-center gap-2.5 rounded-full bg-brand font-sans font-bold uppercase tracking-[0.14em] text-white shadow-lift transition-[background-color,transform] duration-150 ease-out hover:bg-brand-dark active:translate-y-px focus:outline-none focus-visible:ring-2 focus-visible:ring-brand focus-visible:ring-offset-2 focus-visible:ring-offset-cream-100 ${sizing} ${className}`} data-id="element-43" data-mp="10amyyrfqgkwv">
      {children}
      <ArrowRightIcon className="h-4 w-4 transition-transform duration-150 ease-out group-hover:translate-x-0.5" aria-hidden="true" data-id="element-44" data-mp="3jxgool8p2ap8" />
    </a>;
}